import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import classes from './Breadcrumb.module.scss';
import t from '@/utils/Language/Tag-translations';

const Breadcrumb = ({ items, className }) => {
  if (!items || items.length === 0) return null;
  return (
    <nav className={className}>
      <ol className={classes.breadcrumbs}>
        {items.map((item, index) => (
          <li key={index} className={`${classes.breadcrumbItem} ${index === items.length - 1 ? classes.breadcrumbItemActive : ''}`}>
            {index !== 0 && <FontAwesomeIcon icon={['fas', 'chevron-right']} className={classes.breadcrumbChevronRight} />}
            {item.icon && <FontAwesomeIcon icon={[item.icon.style, item.icon.font]} className={classes.breadcrumbLabelIcon} />}
            {item.url ? (
              <a href={item.url} className={classes.breadcrumbItemLabel}>
                {t(item.label)}
              </a>
            ) : (
              <span className={classes.breadcrumbItemLabel}>{t(item.label)}</span>
            )}
          </li>
        ))}
      </ol>
    </nav>
  );
};

export default Breadcrumb;
